import React from 'react';
import {
  CASE_TYPE_NTB,
  ACCESS_TOKEN,
  CASE_TYPE_EXISTING,
  CASE_SUBTYPE,
  API_VERSION,
  NAVIGATION_BACK,
  NAVIGATION_KEY,
  ADDRESS_DURATION_LIMIT,
  NAVIGATION_EXIT,
  LINK_CODE_KEY,
  ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
  ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
  CASE_ID,
  OFFER_CASE_ID,
  RESUME_KEY,
  ROUTE_RESUME_PAGE
} from './constants';
import { getJSON } from 'redux-api-middleware';
import moment from 'moment';
import CBLogo from '../images/favicon-cb.png';
import YBLogo from '../images/favicon-yb.png';
import VMLogo from '../images/vm-favicon.png';
let hrefOnBrowserLoad = '';

export function removeHashUrl(newHash) {
  if (window.history.pushState) {
    window.history.replaceState(
      '',
      '/',
      !newHash ? window.location.pathname : `${window.location.pathname}#${newHash}`
    );
  } else {
    window.location.hash = newHash || '';
  }
}

export function getAnchorTagInString(keyFeatureTitle1, keyFeatureTitle2, hyperlink) {
  return (
    <span>
      {keyFeatureTitle1} {getAnchorTag(keyFeatureTitle2, hyperlink)}
    </span>
  );
}

export function getAnchorTag(content, link) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
}

export function getHyperlink(CBLink, YBLink, bankId) {
  return bankId.toUpperCase() === 'CB' ? CBLink : YBLink;
}

export const saveHrefOnBrowserLoad = () => {
  hrefOnBrowserLoad = window.location.href;
};

export const getHrefOnBrowserLoad = () => hrefOnBrowserLoad;

export const getQueryStringValueByName = function(field, url) {
  const href = url ? url : hrefOnBrowserLoad;
  const reg = new RegExp(`[?&#]${field}=([^&#]*)`);
  const string = reg.exec(decodeURIComponent(href));
  return string ? string[1] : null;
};

export const validateRouteToRedirect = page => {
  return page && hrefOnBrowserLoad.toLowerCase().indexOf(page.toLowerCase().replace('/', '')) > -1;
};

export const getEvidenceUrl = (subtype, caseID) => {
  const caseSubtype = subtype === CASE_TYPE_NTB ? CASE_TYPE_NTB : 'existing/newbusiness';
  return `:api_paas_url/banks/:bank_id/cases/bsap/${caseSubtype}/${caseID}/evidence`;
};

export const getNextTaskUrl = (subtype, caseID) => {
  const caseSubtype = subtype === CASE_TYPE_NTB ? CASE_TYPE_NTB : 'existing/newbusiness';
  return `:api_paas_url/banks/:bank_id/cases/bsap/${caseSubtype}/${caseID}/tasks/next`;
};

export const getCaseSubType = state => {
  const subType = state.config.get(CASE_SUBTYPE);
  return subType ? subType : state.config.get(ACCESS_TOKEN) ? CASE_TYPE_EXISTING : CASE_TYPE_NTB;
};

export const getPayload = (_action, _state, res) =>
  getJSON(res).then(json => {
    res.json = json;
    return json;
  });

export const isEmpty = fieldValue =>
  fieldValue !== 'undefined' &&
  fieldValue !== undefined &&
  fieldValue !== null &&
  fieldValue !== '';

export const getHeaders = () => ({ 'x-bpi-version': API_VERSION });

export const validateAddressHistory = date => {
  const now = moment(new Date());
  const end = moment(date, 'DD-MM-YYYY');
  const duration = moment.duration(now.diff(end));
  return duration.asYears() < ADDRESS_DURATION_LIMIT;
};

export const getElement = id => document.getElementById(id);
export const isBackNavigation = () => getQueryStringValueByName(NAVIGATION_KEY) === NAVIGATION_BACK;

export const getYesNoValues = data => {
  if (data) {
    return data === 'Y' ? 'Yes' : 'No';
  }
  return '';
};
export const isExitNavigation = () => getQueryStringValueByName(NAVIGATION_KEY) === NAVIGATION_EXIT;

export const onKeyPress = event => {
  const ENTER_KEY_CODE = 13;
  if (event.which === ENTER_KEY_CODE) {
    event.preventDefault();
  }
};

export const getLabelByKey = (key, data) => {
  const filterArray = data && data.length > 0 ? data.filter(v => v.value === key) : [];
  if (filterArray && filterArray.length > 0) {
    return filterArray[0].label;
  }
  return '';
};

export const checkValue = val =>
  val && val.trim() !== 'undefined' && val.replace(/ /g, '')
    ? `${val.replace('undefined', '')},
`
    : '';

export const checkEmptyFieldValue = fieldValue => {
  return (
    fieldValue !== 'undefined' &&
    fieldValue !== undefined &&
    fieldValue !== null &&
    fieldValue !== ''
  );
};

export const getCaseID = () =>
  getQueryStringValueByName(OFFER_CASE_ID) || getQueryStringValueByName(CASE_ID);
export const getStartPage = () =>
  getQueryStringValueByName(LINK_CODE_KEY)
    ? ROUTE_BEGIN_YOUR_APPLICATION_PAGE
    : ROUTE_ABOUT_YOUR_APPLICATION_PAGE;

export const applyFaviconBasedOnBrandId = brandId => {
  const head = document.querySelector('head');
  const favicon = document.createElement('link');
  favicon.type = 'image/x-icon';
  favicon.rel = 'shortcut icon';
  favicon.href = brandId === 'VM' ? VMLogo : brandId === 'YB' ? YBLogo : CBLogo;
  favicon && head.appendChild(favicon);
};
export const showNeedHelpSidePanel = (pathname, resumeType) => {
  return resumeType === RESUME_KEY && pathname === ROUTE_RESUME_PAGE;
};

export const setResumeHrefParam = (caseId, type, productName) => {
  hrefOnBrowserLoad = hrefOnBrowserLoad.concat(`&caseId=${caseId}&caseType=${type}&productName=${productName}
  `);
};

export const setResumeTaskUriHref = taskUri => {
  hrefOnBrowserLoad = hrefOnBrowserLoad.concat(`&task_uri=${taskUri}`);
};

export const setSecondaryApplicantNTB = () => {
  hrefOnBrowserLoad = hrefOnBrowserLoad.concat(`&${CASE_SUBTYPE}=${CASE_TYPE_NTB}`);
};
